import { storeCreator } from '@/utils/store/store.utils';

interface State {
  isDismissed: boolean;
  setIsDismissed: (isDismissed: boolean) => void;
}

const useStore = storeCreator<State>((set) => ({
  isDismissed: false,
  setIsDismissed: (isDismissed) => set(() => ({
    isDismissed,
  })),
}));

export const useDismissBalanceReminderStore = () => useStore();

export default useDismissBalanceReminderStore;
